import type { FaireProductEntity } from "../../entity_types/product";

export const p_hktqhc7ram: FaireProductEntity = {
  token: "p_hktqhc7ram",
  type: "product",
  name: "Zen Water 12/1L Plastic Bottle",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/973a8b41ddb9396eb5c56032f62dfa29200cd58a4922dca265e80f38d070550c.jpeg",
  galleryImageUrls: [],
  priceDollars: 40.18,
  description:
    "Balanced, mineral-enhanced alkaline water in 1L bottles. Case of 12.",
  tags: [],
  msrpDollars: 80.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:53.126Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
